module.exports = __webpack_public_path__ + "static/media/CC20-AP140-12.a0ac2e9e.png";